<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Dodaj kod odpadu
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="waste-code--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    ref="code"
                    v-model="form.code"
                    :rules="formRules.code"
                    label="Kod"
                    class="wastemaster-input-elevation"
                    autofocus
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-select
                    :items="getUnits()"
                    ref="unit"
                    v-model="form.unit"
                    :rules="formRules.unit"
                    item-value="key"
                    item-text="value"
                    label="Jednostka"
                    class="wastemaster-input-elevation"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-textarea
                    ref="description"
                    v-model="form.description"
                    :rules="formRules.description"
                    label="Opis"
                    class="wastemaster-input-elevation"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  large
              >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import transactionTypeMixin from "@/mixins/transactionTypeMixin";
import transportConditionMixin from "@/mixins/transportConditionMixin";
import categoryMixin from "@/mixins/categoryMixin";
import priceMixin from "@/mixins/priceMixin";
import paymentConditionMixin from "@/mixins/paymentConditionMixin";
import dateMixin from "@/mixins/dateMixin";
import validationHelpers from '@/mixins/validationHelpers'
import unitMixin from "@/mixins/unitMixin";

export default {
  name: 'ModalAddDimension',
  components: {  },
  props: {
    item: {},
  },
  mixins: [
      transactionTypeMixin,
      transportConditionMixin,
      categoryMixin,
      priceMixin,
      paymentConditionMixin,
      dateMixin,
      validationHelpers,
      unitMixin
  ],
  created() {
  },
  data: () => ({
    dialog: false,
    form: {
      code: '',
      unit: '',
      description: '',
    },
    formRules: {
      code: [
          value => !!value || 'Wpisz kod',
          value => /^[0-9]{6}\*?$/.test(value) || 'Wpisz poprawny kod',
          ],
      description: [value => !!value || 'Wpisz opis'],
      unit: [value => !!value || 'Wybierz jednostkę'],
    },
    valid: false,
  }),
  methods: {
    open() {
      this.dialog = true
    },
    async onSubmit() {
      console.log(this.$refs.newForm.validate());
      if (!this.$refs.newForm.validate()) {
        return
      }

      const wasteCode = {
        code: this.form.code,
        unit: this.form.unit,
        description: this.form.description,
      }
      api
          .post('/api/companies/' + this.item + '/waste-codes' , wasteCode)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Kod został dodany.',
            });
            this.dialog = false;
            this.form.code = '';
            this.form.unit = '';
            this.form.description = '';
            this.$parent.getWasteCodes();
          })
          .catch((error) => {
            console.error('Error when adding a dimension:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
